var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10C23.1858 10 22.8838 10.1208 22.6542 10.3504L9.4712 21.1288C9.4712 21.1288 9.4471 21.1529 9.4229 21.165L9.3746 21.2013H9.3867C9.145 21.4308 9 21.7571 9 22.0833C9 22.7479 9.5437 23.2917 10.2083 23.2917H11.4167V36.5833C11.4167 37.9125 12.4921 39 13.8333 39H33.1667C34.4958 39 35.5833 37.9125 35.5833 36.5833V23.2917H36.7917C37.4563 23.2917 38 22.7479 38 22.0833C38 21.745 37.855 21.4308 37.6133 21.2013H37.5892C37.5892 21.2013 37.5408 21.1408 37.5046 21.1167L34.3629 18.555V13.625C34.3629 12.9604 33.8192 12.4167 33.1546 12.4167H31.9463C31.2817 12.4167 30.7379 12.9604 30.7379 13.625V15.5825L24.3217 10.3263C24.1042 10.1208 23.8021 10 23.5 10ZM15.0417 35.8946V33.3088H22.2192V35.8946H15.0417ZM15.0417 30.8317V28.2458H29.4088V30.8317H15.0417ZM15.0417 25.7688V23.1829H22.2192V25.7688H15.0417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeParagraph);
export default __webpack_public_path__ + "static/media/home-paragraph.680ca12ed75b00e6269e2254c01c235c.svg";
export { ForwardRef as ReactComponent };